export const STAKE_PERCENT_OPTIONS = [
  { percent: 25 },
  { percent: 50 },
  { percent: 75 },
  { percent: 100, label: 'MAX' },
]
